export class ModelPerfPredict {
  current = new PerformancePredictionFields();
  predict = new PerformancePredictionFields();
  diff = new PerformancePredictionFields();
}

export class PerformancePredictionFields {
  investment = 0;
  fairValue = 0;
  moic = 0;
}
